import React, {useEffect, useState} from 'react'
import { Row, Col  } from "antd";
import { ATMenu } from '../ATMenu';
import { FilterView } from '../../Home/FilterView';
import { DataView } from '../../Home/DataView';
import { Insights } from '../../Home/Insights';
import { FilterModalView } from '../../Home/FilterModalView';
import { HazardDetailsView } from '../../Home/Hazards/HazardDetailsView';
import { cleanDepartment } from '../../../util/details';

export const HazardATContainerView = ({
    data, 
    client, 
    current, 
    setCurrent, 
    isRep,
    setRefetchData,
    refetchData
}) => {
    const [filterDetails, setFilterDetails] = useState({
        location: undefined,
        status: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        observationType: [],
        search: ''
    });
    const [myFilters, setMyFilters] = useState([]);
    const [myFilteredList, setMyFilteredList] = useState(data);
    const [modalDetails, setModalDetails] = useState({show: false, insights: false});
    const [detailsViewModal, setDetailsViewModal] = useState({show: false, id: undefined, actionID: undefined})
    

    const handleFilterChange = (key, value) => {
    
        let newFilters = [...myFilters];
    
        const filterIndex = newFilters.findIndex(filter => filter.key === key);
        if (value === 'none' || value === '') {
            if (filterIndex !== -1) {
                newFilters.splice(filterIndex, 1);
            }
        } else {
            const newFilter = { key, value };
            if(key === 'observationType'){
                if (value.length === 0) {
                    if (filterIndex !== -1) {
                        newFilters.splice(filterIndex, 1);
                    }
                } else {
                    const newFilter = { key, value };
                    if (filterIndex !== -1) {
                        newFilters[filterIndex] = newFilter;
                    } else {
                        newFilters = [
                            ...newFilters,
                            newFilter
                        ]
                    }
                }
            }else{
                if (filterIndex !== -1) {
                    newFilters[filterIndex] = newFilter;
                } else {
                    newFilters = [
                        ...newFilters,
                        newFilter
                    ]
                }
            }
        }

        let filteredCards = [...data];
        newFilters.forEach(filter => {
            
            if(filter.key === 'location'){
                filteredCards = filteredCards.filter(card => card.location === filter.value);
            }

            if(filter.key === 'department'){
                filteredCards = filteredCards.filter(card => cleanDepartment(card.businessUnit) === filter.value);
            }

            if(filter.key === 'status'){
                filteredCards = filteredCards.filter(card => card.status === filter.value);
            }

            if (filter.key === 'dateFrom') {
                filteredCards = filteredCards.filter(card => new Date(card.dateObserved) >= new Date(filter.value));
            }
    
            if (filter.key === 'dateTo') {
                filteredCards = filteredCards.filter(card => new Date(card.dateObserved) <= new Date(filter.value));
            }

            if ((filter.key === 'observationType') && filter.value.length > 0) {
                filteredCards = filteredCards.filter(card => 
                    filter.value.includes(card.observationType)
                );
            }

            if(filter.key === 'search' && (current === 'myactions' || current === 'assignedactions')){
                const searchLower = filter.value.toLowerCase();
                filteredCards = filteredCards.filter(action =>
                    action.action.toLowerCase().includes(searchLower) ||
                    action.status.toLowerCase().includes(searchLower) ||
                    action.location.toLowerCase().includes(searchLower) ||
                    action.dateObserved.toLowerCase().includes(searchLower)
                );
            }

        })

        const newFilteredCards = [...filteredCards]
        let newValue = value === 'none' ? undefined : value;
        switch (key) {
            case "location":
                setFilterDetails({
                    ...filterDetails,
                    location: newValue
                });
                break;
            case "department":
                setFilterDetails({
                    ...filterDetails,
                    department: newValue
                });
                break;
            case "status":
                setFilterDetails({
                    ...filterDetails,
                    status: newValue
                });
                break;
            case "dateFrom":
                setFilterDetails({
                    ...filterDetails,
                    dateFrom: newValue
                });
                break;
            case "dateTo":
                setFilterDetails({
                    ...filterDetails,
                    dateTo: newValue
                });
                break;
            case "observationType":
                setFilterDetails({
                    ...filterDetails,
                    observationType: newValue
                });
                break;
            case "search":
                setFilterDetails({
                    ...filterDetails,
                    search: newValue
                });
                break;
            default:
                break;
        }
        setMyFilteredList(newFilteredCards);
        setMyFilters(newFilters);
    }

    const handleClearAllFilters = () => {
        setFilterDetails({
            location: undefined,
            status: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            observationType: [],
        });
        setMyFilteredList(data);
        setMyFilters([]);
    }

    useEffect( () => {
        setMyFilteredList(data);
    }, [data])

    return (
        <>
            {modalDetails.show && !modalDetails.insights && <>
                <FilterModalView 
                    setModalDetails={setModalDetails} 
                    filterDetails = {filterDetails}
                    handleFilterChange = {handleFilterChange}
                    handleClearAllFilters = {handleClearAllFilters}
                />
            </>}

            {modalDetails.show && modalDetails.insights && <>
                <div className="modal-overlay">
                    <Row
                        style={{
                            paddingTop: "20px",
                            paddingBottom: "20px",
                            height: "100dvh",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "start"
                        }}
                    >
                        <Col 
                            span={18}
                            style={{height: "65dvh"}}
                        >
                            <div className="modal">
                                <Row
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        height: "100%"
                                    }}
                                >
                                    <Col
                                        span={12}
                                        style={{
                                            height: "100%",
                                            paddingTop: "20px",
                                            
                                        }}
                                    >
                                        <Insights 
                                            data = {myFilteredList} 
                                            tab = {current} 
                                            modalDetails = {modalDetails} 
                                            setModalDetails = {setModalDetails}
                                            myData = {true}
                                        />
                                    </Col>
                                </Row>
                                
                            </div>
                        </Col>
                    </Row>
                    
                </div>
            </>}

            {detailsViewModal.show && <>
                <HazardDetailsView
                    client = {client}
                    setDetailsViewModal = {setDetailsViewModal}
                    detailsViewModal = {detailsViewModal}
                    isRep = {isRep}
                    viewOnly = {current === 'myactions' ? true : false}
                    assignedView={current === 'assignedactions' ? true : false}
                    actionID={detailsViewModal.actionID}
                    setRefetchData = {setRefetchData}
                    refetchData = {refetchData}
                />
            </>}
           <ATMenu current={current} setCurrent={setCurrent} />
           <Row
                style={{
                    paddingLeft: "10px"
                }}
                className="atDataContainer"
            >
                <Col
                    xl={{span: 20}}
                    lg={{span: 20}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}}
                    style={{
                       height: "100%"
                    }}
                >
                    <Row
                        style={{
                            boxShadow: "0 0px 8px -2px rgb(0, 0, 0, 0.1)",
                            borderRadius: "4px",
                            height: "98%"
                        }}
                    >
                        <Col
                            span={24}
                        >
                            <FilterView
                                modalDetails = {modalDetails} 
                                setModalDetails = {setModalDetails} 
                                filterDetails = {filterDetails}
                                handleFilterChange = {handleFilterChange} 
                                handleClearAllFilters = {handleClearAllFilters}
                                current = {current}
                            />
                            <DataView
                                cards = {myFilteredList} 
                                current = {current}
                                setDetailsViewModal = {setDetailsViewModal}
                                detailsViewModal = {detailsViewModal}
                            />
                        </Col>
                    </Row>
                    
                </Col>

                {/* <Col
                    span={1}
                >
                
                </Col> */}

                <Col
                    xl={{span: 4}}
                    lg={{span: 4}}
                    md={{span: 0}}
                    sm={{span: 0}}
                    xs={{span: 0}}
                    style={{
                        height: "100%",
                        padding: "10px",
                    }}
                >
                    <Insights
                        data = {myFilteredList} 
                        tab = {current} 
                        modalDetails = {modalDetails} 
                        setModalDetails = {setModalDetails}
                        myData = {true}
                    />
                </Col>
            </Row>
        </>
    )
}
